import React from 'react'
import { ProgressBar } from '@astryxdesign/core/ProgressBar'
import { HStack } from '@astryxdesign/core/Layout'
import { Text } from '@astryxdesign/core/Text'

interface ManuscriptFooterProps {
  /** Words added to this story today, as counted by the server. */
  wordsToday: number
  /** This story's daily word goal. Never below MIN_DAILY_GOAL. */
  goal: number
  /** Opens story settings on the Daily goal section. */
  onEditGoal: () => void
}

export default function ManuscriptFooter({
  wordsToday,
  goal,
  onEditGoal
}: ManuscriptFooterProps): React.JSX.Element {
  const hasMetGoal = wordsToday >= goal

  return (
    <footer className="manuscript-footer" aria-label="Daily writing goal">
      <HStack gap={4} align="center" justify="end" className="manuscript-footer-inner">
        {/* Kept mounted rather than conditionally rendered so the count stays available to
            screen readers, which never trigger the hover that reveals it visually. */}
        <Text type="supporting" className="manuscript-footer-today">
          {hasMetGoal && <span aria-hidden="true">✓ </span>}
          {wordsToday.toLocaleString()} {wordsToday === 1 ? 'word' : 'words'} today
        </Text>
        <button type="button" className="manuscript-footer-goal-button" onClick={onEditGoal}>
          Daily Goal: {goal.toLocaleString()} words
        </button>
        <ProgressBar
          label="Progress toward today's writing goal"
          isLabelHidden
          // Clamped so an over-achieving day renders a full bar rather than an invalid one.
          value={Math.min(wordsToday, goal)}
          max={goal}
          variant={hasMetGoal ? 'success' : 'accent'}
        />
      </HStack>
    </footer>
  )
}
